const t = {
  CATALOG_SET_PROVIDER: 'CATALOG_SET_PROVIDER',
  CATALOG_ADD_SELECTED_ITEM: 'CATALOG_ADD_SELECTED_ITEM',
  CATALOG_REMOVE_SELECTED_ITEM: 'CATALOG_REMOVE_SELECTED_ITEM',
  CATALOG_CLEAR_SELECTED_ITEMS: 'CATALOG_CLEAR_SELECTED_ITEMS',
  CATALOG_SET_SEARCH_QUERY: 'CATALOG_SET_SEARCH_QUERY',
  CATALOG_SET_FILTERS: 'CATALOG_SET_FILTERS',
  CATALOG_RESET: 'CATALOG_RESET',
};

export default t;
